import Axios from 'axios';
import { useContext, useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import DashboardContext from 'Context';
import PropTypes from 'prop-types';
import { Skeleton } from 'antd';

export default function InputControl({
  url,
  name,
  label,
  width,
  isClear,
  isMulti,
  disabled,
  handelValue,
  defaultValue,
  command = {},
  isPost = false,
  fromHcm = false,
  dependency = {},
  staticData = [],
  isAnException = false,
  isUserAddress = false,
  filteredElement = null,
  hasDefValueOnPurpose = false,
}) {
  const { authentication, urldashboard, handelloding, handelerrors, urlHcm } =
    useContext(DashboardContext);
  const selectInputRef = useRef();
  const [loading, setLoading] = useState(false);
  const [arrystate, setArrystate] = useState([]);
  const [dataIsNull, setDataIsNull] = useState(false);
  const [firstRender, setFirstRender] = useState(true);

  const preventedRenderingAtFirst = useRef(true);

  const dataFeching = async () => {
    setLoading(true);

    if (dependency?.defaultDiscountCouponId && firstRender) {
      return setFirstRender(false);
    }

    if (staticData?.length > 0) {
      setLoading(false);
      return setArrystate(staticData);
    }

    try {
      const res = isPost
        ? await Axios.post(
          `${fromHcm ? urlHcm : urldashboard}${url}`,
          command,
          {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json; charset=utf-8 ',
            },
          }
        )
        : await Axios.get(`${fromHcm ? urlHcm : urldashboard}${url}`, {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8',
          },
        });
      const data = await res?.data;
      if (data?.data === null) {
        setDataIsNull(true);
      } else {
        setDataIsNull(false);
        if (isAnException) {
          setArrystate(
            data?.data?.map((item) => {
              return {
                label: isUserAddress ? item?.userAddress : item?.title,
                value: isUserAddress ? item?.id : item?.groupId,
              };
            })
          );
        } else if (fromHcm) {
          setArrystate(
            data?.map((item) => {
              return {
                label: item?.value,
                value: item?.key,
              };
            })
          );
        } else {
          setArrystate(
            filteredElement
              ? data?.data?.filter((item) => item.value !== filteredElement)
              : data?.data
          );
        }
        handelloding(false);
      }
      setLoading(false);
    } catch (error) {
      handelerrors(error);
      handelloding(false);
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    if (event) {
      if (isMulti) {
        handelValue(
          name,
          event.map((res) => res?.value)
        );
      } else {
        handelValue(name, event.value);
      }
    } else {
      handelValue(name, event);
    }
  };

  useEffect(() => {
    dataFeching();
    if (defaultValue !== null && defaultValue !== undefined && hasDefValueOnPurpose) handelValue(name, defaultValue);
    if (isClear) {
      selectInputRef.current.select.clearValue();

      handelValue(name, null);
    }
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClear, url]);

  useEffect(() => {
    if (preventedRenderingAtFirst.current) {
      preventedRenderingAtFirst.current = false;
      return;
    }

    if (dependency && Object?.values(dependency)?.some((val) => val)) {
      dataFeching();
    }
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dependency?.date,
    dependency?.userId,
    dependency?.groupId,
    dependency?.categoryId,
    dependency?.orderStartDate,
    dependency?.defaultDiscountCouponId,
  ]);

  return (
    <Form.Group style={{ width: width ?? 'inherit' }}>
      {label && <Form.Label>{label}</Form.Label>}
      {loading ? (
        <Skeleton.Input block size='large' />
      ) : defaultValue !== undefined ? (
        <Select
          className='basic-single'
          classNamePrefix='select'
          styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
          ref={selectInputRef}
          defaultValue={
            arrystate?.filter((item) => item.value === defaultValue)[0]
          }
          onChange={handleChange}
          isLoading={arrystate?.length > 0 ? false : true}
          isRtl
          isDisabled={disabled}
          isMulti={isMulti ? true : false}
          isClearable
          name={name}
          options={[
            {
              label: label,
              options: arrystate,
            },
          ]}
        />
      ) : (
        <Select
          className='basic-single'
          classNamePrefix='select'
          styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
          onChange={handleChange}
          isLoading={arrystate?.length > 0 ? false : true}
          isRtl
          isClearable
          ref={selectInputRef}
          isDisabled={disabled}
          isMulti={isMulti ? true : false}
          name={name}
          options={[
            {
              label: label,
              options: arrystate,
            },
          ]}
        />
      )}
    </Form.Group>
  );
}

InputControl.propTypes = {
  /**لیبل اینپوت است */
  label: PropTypes.string,
  /**برای ارسال مقدار اولیه برای اینپوت است */
  defaultValue: PropTypes.string,
  /** نام اینپوت است */
  name: PropTypes.string,
  /** ارسال مقدار اینپوت به بالا است */
  handelValue: PropTypes.func,
  /**آدرس که برای دریافت داده استفاده می شود */
  url: PropTypes.string,
  /**برای فعال بودن یا غیر فعال بودن اینپوت است */
  disabled: PropTypes.bool,
  /**برای حذف مقدار از اینپوت است */
  isClear: PropTypes.bool,
};
